import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { FuseNavigationModule } from '@fuse/components';


import { NavbarVerticalStyle1Component, SafeHtml2 } from 'app/layout/components/navbar/vertical/style-1/style-1.component';

@NgModule({
    imports: [
    MatButtonModule,
    MatIconModule,
    FuseNavigationModule,
    NavbarVerticalStyle1Component,
    SafeHtml2
],
    exports: [
        NavbarVerticalStyle1Component
    ]
})
export class NavbarVerticalStyle1Module {
}